import ajax from './ajax'; // 引用二次封装ajax.js
export default {

  // 获取我的站内信列表
  msgRemindList (params) {
    return ajax.get('/common/tuserMsgRemind/crmCustomerMsgRemindList.ht', params);
  },
  // 查看站内信
  msgDetails (params) {
    return ajax.get('/common/tuserMsgRemind/crmCustomerMsgRemindDetail.ht', params);
  },
  // 删除站内信
  deletMsg (params) {
    const url = `/common/tuserMsgRemind/crmCustomerMsgDel.ht?tokenId=${localStorage.getItem('dl_tokenId_bl')}`;
    return ajax.postForm(url, params);
  },
  // 站内信未读数量
  unRead (params) {
    return ajax.get('/common/tuserMsgRemind/crmCustomerMsgCount.ht', params);
  }

};



// WEBPACK FOOTER //
// ./src/api/message.js